module.exports = __webpack_public_path__ + "static/media/Leash_AnimalPrint_01.ead79c4e.png";